import React from 'react';
import financeService from '../../../../services/financeService';
import { Reconciliation } from '../../../../types/finance';
import { useAuth } from '../../../../context/AuthContext';
import { usePdfExport, useSchoolBranding } from '../../../../utils/pdf';
import DownloadMenu from '../../../common/DownloadMenu';
import ReconciliationDocument from '../../pdf/ReconciliationDocument';

/** The whole reconciliation as a PDF (drawn here, from what the screen holds) or a CSV (from the server). */
const ReconciliationDownload: React.FC<{ rec: Reconciliation }> = ({ rec }) => {
  const { currency } = useAuth();
  const { generate } = usePdfExport();
  const { branding } = useSchoolBranding();
  const onExport = async (format: 'pdf' | 'csv') => {
    if (format === 'csv') return financeService.exportReconciliationCsv(rec._id);
    await generate(
      <ReconciliationDocument rec={rec} currency={currency || 'PKR'} branding={branding} generatedAt={new Date().toISOString()} />,
      `Bank_Reconciliation_${rec.accountCode}_${rec.statementDate}.pdf`,
    );
  };
  return <DownloadMenu heading="The whole reconciliation" onExport={onExport} />;
};

export default ReconciliationDownload;
